export default {
  notfound: {
    title: 'Ova stranica još nije izrađena',
    hint: 'Recite mi više o ovoj stranici kako bih je mogao izraditi',
  },
};